import { isClosed, localDate } from './journal-metrics';

export function recordedReturn(trade) {
  if (!isClosed(trade)) return null;
  if (trade.result === 'BE') return 0;
  if (trade.returnPct == null || String(trade.returnPct).trim() === '') return null;
  const value = Number(String(trade.returnPct).replace(/%/g, ''));
  return Number.isFinite(value) ? value : null;
}

export function calendarMonth(trades, year, month, includeArchived = false) {
  const days = new Date(year, month + 1, 0).getDate();
  const offset = (new Date(year, month, 1).getDay() + 6) % 7;
  const prefix = localDate(new Date(year, month, 1)).slice(0, 7);
  const byDay = new Map();
  trades.filter(trade => !trade.deleted && (includeArchived || !trade.archiveFolderId)).forEach(trade => {
    if (!trade.date?.startsWith(`${prefix}-`)) return;
    const day = Number(trade.date.slice(8));
    if (!Number.isInteger(day) || day < 1 || day > days || trade.date !== `${prefix}-${String(day).padStart(2, '0')}`) return;
    const info = byDay.get(day) || { date: trade.date, day, trades: [], values: [], total: 0 };
    info.trades.push(trade);
    const value = recordedReturn(trade);
    if (value !== null) { info.values.push(value); info.total += value; }
    byDay.set(day, info);
  });
  const weeks = Array.from({ length: Math.ceil((offset + days) / 7) }, (_, row) => {
    const cells = Array.from({ length: 7 }, (_, column) => {
      const day = row * 7 + column - offset + 1;
      return day < 1 || day > days ? null : byDay.get(day) || { day, date: `${prefix}-${String(day).padStart(2, '0')}`, trades: [], values: [], total: 0 };
    });
    return { cells, total: cells.reduce((sum, cell) => sum + (cell?.total || 0), 0), reported: cells.reduce((sum, cell) => sum + (cell?.values.length || 0), 0), count: cells.reduce((sum, cell) => sum + (cell?.trades.length || 0), 0) };
  });
  return { weeks, total: weeks.reduce((sum, week) => sum + week.total, 0), reported: weeks.reduce((sum, week) => sum + week.reported, 0), count: weeks.reduce((sum, week) => sum + week.count, 0) };
}
